import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledEnrichmentCarLoader = styled(FlexColumn)`
    display: flex;
    justify-content: left;
    gap: 8px;
`;
